// extracted by mini-css-extract-plugin
module.exports = {"error-alert":"classes_error-alert__fh0lV","variant-compact":"classes_variant-compact__3hh8C","variant-inline":"classes_variant-inline__YKrzH","action":"classes_action__gqI5U"};